/****************************************************************************************************
* hore -> page-home > photo-retouching
****************************************************************************************************/
import { decimalPlace } from './utils';
import { hophElsControl } from './page-home-photo';

///// jess: test: Google search: gsap scrolltrigger scrub when window height is float 1 pxel gap

////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let horeIsSnippet = true;
// if(horeIsSnippet && typeof horeIsRevert !== 'undefined') horeScrollClear();



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let windowH ; // jess: windowH instead of window.innerHeight

let horeSel = '.sector.photo-retouching ';

let horeContentW; // eslint-disable-line no-unused-vars
let horeBoardsW; // eslint-disable-line no-unused-vars

let horeBrushLineLen = 9041;
let horeBrushLineScale;

///////// Get boards' length
const getBoardsWidth = () => Array.from(document.querySelectorAll(`.sector.photo-retouching .board-wrapper .board`)).reduce((a, b) => a + b.offsetWidth, 0);

///////// Get retouching content's length
const getContentWidth = () => {
  let marginW = parseInt(window.getComputedStyle(document.querySelector(`.sector.photo-retouching .retouch-content-a .retouch1`)).marginLeft);
  // let w = Array.from(document.querySelectorAll(`.sector.photo-retouching .retouch-content-a > div:not(.rect-back)`)).reduce((a, b) => a + b.offsetWidth, 0);
  let w = document.querySelector(`.sector.photo-retouching .retouch-content-a .sector-copies`).offsetWidth;
  w += Array.from(document.querySelectorAll(`.sector.photo-retouching .retouch-content-a .retouch`)).reduce((a, b) => a + b.offsetWidth, 0);
  w += document.querySelector(`.sector.photo-retouching .retouch-content-a .retouch-spare`).offsetWidth;
  return w + marginW * 10;
}



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll & Animation
let horeScrollTl1; // eslint-disable-line no-unused-vars
let horeScrollTl2; // eslint-disable-line no-unused-vars
let horeRetouchOnTl; // eslint-disable-line no-unused-vars
let horeContentTl; // eslint-disable-line no-unused-vars
let horeContentDrag; // eslint-disable-line no-unused-vars
let horeTitle; // eslint-disable-line no-unused-vars


////////////////////////////////////////////////// Init
const horeInit = (gsapRef, splitTextRef) => {
  windowH = document.documentElement.getBoundingClientRect().height;
  // windowH = decimalPlace(document.documentElement.getBoundingClientRect().height);
  // windowH = window.innerHeight;

  horeBoardsW = getBoardsWidth();
  horeContentW = getContentWidth();
  // gsapRef.set('.sector.spacer-retouch', {height: horeContentW - horeBoardsW});
  // gsapRef.set('.sector.spacer-retouch', {height: windowH});
  gsapRef.set('.sector.spacer-retouch', {height: horeContentW - horeBoardsW - windowH});
  
  // gsapRef.set(`${horeSel} .container-in`, {clearProps: 'all'});
  // gsapRef.set(`${horeSel} .container-in`, {y: -1 * Math.floor(windowH)});

  gsapRef.set(`${horeSel} .container-in`, {y: -1 * windowH});
  // gsapRef.set(`${horeSel} .container-in`, {y: '-100%'});

  gsapRef.set(`${horeSel} .contents-bg `, {x: '-50%', scale: 1.1, opacity: 0.3});

  gsapRef.set(`${horeSel} .cloud-in `, {clearProps: 'all'});
  gsapRef.set(`${horeSel} .cloud-in `, {opacity: 0.3});

  gsapRef.set(`${horeSel} .board-wrapper`, {pointerEvents: 'none'});

  gsapRef.set(`${horeSel} .board`, {clearProps: 'all'});
  
  gsapRef.set(`${horeSel} .retouch-content`, {clearProps: 'all'});
  
  // gsapRef.set(`${horeSel} .retouch-content .rect-back`, {clearProps: 'all'})

  horeTitle = new splitTextRef(`${horeSel} .retouch-content .sector-copy.title .copy`, {type: 'chars,words', charsClass:'char char++'});
  gsapRef.set(`${horeSel} .retouch-content .sector-copy.title .copy `, {x: '0%'});
  gsapRef.set(`${horeSel} .retouch-content .sector-copy.title .copy .char`, {transformOrigin: 'left center', autoAlpha: 0, rotationX: '70deg', y: '20%', x: '-70%'});
  gsapRef.set(`${horeSel} .retouch-content .sector-copy.sentance .copy .span`, { clearProps: 'all' });
  gsapRef.set(`${horeSel} .retouch-content .sector-copy.sentance .copy .span`, { autoAlpha: 0,  y: '70%'}); 
  gsapRef.set(`${horeSel} .retouch-content .sector-copy.sentance .copy .span-in `, {x: '0%'});

  horeBrushLineScale = ((window.innerWidth > window.innerHeight) ? window.innerHeight : window.innerWidth) / 1000 * 2;
  gsapRef.set('.brush-g', {transformOrigin: 'center center', x: (window.innerWidth - 2000) / 2, y: (window.innerHeight - 2000) / 2});
  gsapRef.set('#brush-rect-g', {scaleX: ((window.innerWidth + 200) / 2000), scaleY: ((window.innerHeight + 200) / 2000)});
  gsapRef.set('#brush-line-g', {scale: (window.innerWidth * 0.5) / 2000});
  gsapRef.set('#brush-rect', {fill: '#000000'})
  gsapRef.set('#brush-line', {strokeDashoffset: horeBrushLineLen});
}

////////////////////////////////////////////////// Scroll
const horeScrollMake = (gsapRef, scrollTriggerRef, smootherRef, draggableRef) => {

  ////////////////////////////// Retouch content sliding while scrolling
  // horeContentTl = gsapRef.to(`${horeSel} .retouch-content`, {paused: true, x: () => `-${horeContentW - horeBoardsW}` , ease: 'none'});
  horeContentTl = gsapRef.timeline({paused: true})

    .addLabel('t0', 0)

    .to(`${horeSel} .contents-bg `, {duration: 5, x: '-20%', ease: 'none'}, 't0')
    .to(`${horeSel} .cloud1-in `, {duration: 5, x: '20%', scale: 0.8, ease: 'none'}, 't0')
    .to(`${horeSel} .cloud2-in `, {duration: 5, x: '-40%', scale: 0.5, ease: 'power1.out'}, 't0')
    .to(`${horeSel} .cloud3-in `, {duration: 5, x: '40%', scale: 1.3, ease: 'none'}, 't0')
    .to(`${horeSel} .cloud4-in `, {duration: 5, x: '40%', scale: 1.2, ease: 'none'}, 't0')

    .to(`${horeSel} .retouch-content .sector-copy.title .copy`, {duration: 0.75, x: '-70%', ease: 'none'}, 't0')
    .to(`${horeSel} .retouch-content .sector-copy.sentance .copy .span-in1`, {duration: 0.75, x: '-450%', ease: 'none'}, 't0+=0.15')
    .to(`${horeSel} .retouch-content .sector-copy.sentance .copy .span-in2`, {duration: 0.75, x: '-1000%', ease: 'none'}, 't0+=0.3')
    
    .to(`${horeSel} .retouch-content`, {duration: 5, x: () => `-${horeContentW - horeBoardsW}` , ease: 'none'}, 't0')
    
    // .to(`${horeSel} .retouch-content .rect-back1`, {duration: 5, x: `+=${horeContentW-(window.innerWidth*1.4)}` , ease: 'power1.out'}, 't0')
    // .to(`${horeSel} .retouch-content .rect-back2`, {duration: 5, x: `+=${horeContentW-(window.innerWidth*1.4)}` , ease: 'power2.inOut'}, 't0')
    // .to(`${horeSel} .retouch-content .rect-back3`, {duration: 5, x: `+=${horeContentW-(window.innerWidth*1.4)}` , ease: 'power1.out'}, 't0')
    // .to(`${horeSel} .retouch-content .rect-back4`, {duration: 5, x: `+=${horeContentW-(window.innerWidth*1.4)}` , ease: 'power2.out'}, 't0')
    // .to(`${horeSel} .retouch-content .rect-back5`, {duration: 5, x: `+=${horeContentW-(window.innerWidth*1.4)}` , ease: 'power1.out'}, 't0')
    // .to(`${horeSel} .retouch-content .rect-back6`, {duration: 5, x: `+=${horeContentW-(window.innerWidth*1.4)}` , ease: 'power2.out'}, 't0')
    // .to(`${horeSel} .retouch-content .rect-back7`, {duration: 5, x: `+=${horeContentW-(window.innerWidth*1.4)}` , ease: 'power2.inOut'}, 't0')
    ;
  
  
  ////////////////////////////// Scroll1: Pin retouch over photo & retouch slide
  // horeScrollTl1 = gsapRef.timeline({
  //   scrollTrigger: {
  //   id: 'horeScrollTl1',
  //   trigger: horeSel,
  //   toggleActions: 'restart complete reverse reset',
  //   start: 'top bottom',
  //   end: `top top`,
  //   scrub: true,
  //   toggleClass: 'horeScrollTl1-active',
  //   onEnter: (self) => {},
  //   onLeave: (self) => {},
  //   onEnterBack: (self) => {},
  //   onLeaveBack: (self) => {},
  //   // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
  //   }
  // })
  // .to(`${horeSel} .container-in`, {duration: 1, y: `0`, ease: 'none'}, 0)
  // ;

  //////// Test how the numbers are calculated related to decimal places
  // console.log(`windowH:${windowH}, decimalPlace(windowH):${decimalPlace(windowH)}, horeContentW:${horeContentW}, horeBoardsW:${horeBoardsW}, (horeContentW - horeBoardsW):${(horeContentW - horeBoardsW)}, (windowH + horeContentW - horeBoardsW):${(windowH + horeContentW - horeBoardsW)}`);
  // console.log(`(decimalPlace(windowH) + horeContentW - horeBoardsW):${(decimalPlace(windowH) + horeContentW - horeBoardsW)}, (decimalPlace(windowH + horeContentW - horeBoardsW)):${(decimalPlace(windowH + horeContentW - horeBoardsW))}`);
  
  horeScrollTl1 = gsapRef.timeline({
    scrollTrigger: {
    id: 'horeScrollTl1',
    trigger: horeSel,
    // start: 'top bottom',
    start: `top ${windowH}px`,
    // trigger: '.sector.spacer-graphic',
    // start: 'top top',

    // end: `+=${horeContentW - horeBoardsW}` , // Used from .spacer-retouch

    // end: () => {console.log(`====> +=${decimalPlace(windowH + horeContentW - horeBoardsW)}px`); return `+=${decimalPlace(windowH + horeContentW - horeBoardsW)}px`} , // Used from .spacer-retouch
    // end: `+=${windowH + horeContentW - horeBoardsW + windowH*0.5}px`, // Used from .spacer-retouch, windowH*0.5 to make sure pin while contact showing
    end: `+=${windowH + horeContentW - horeBoardsW}px`, // Used from .spacer-retouch, windowH*0.5 to make sure pin while contact showing
    // end: `+=${100 + (horeContentW - horeBoardsW) / windowH * 100}%` , // Used from .spacer-retouch

    // end: `top -100%` , // Used from .spacer-retouch
    // end: `top -${windowH}` , // Used from .spacer-retouch

    // endTrigger: '.sector.spacer-retouch',
    // end: 'bottom bottom',
    toggleActions: 'restart complete reverse reset',
    scrub: true,
    toggleClass: 'horeScrollTl1-active',
    onEnter: (self) => {},
    onLeave: (self) => {},
    onEnterBack: (self) => {},
    onLeaveBack: (self) => {},
    // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    }
  })
  // .to(`${horeSel} .container-in`, {duration: 2, y: `+=${horeContentW - horeBoardsW}`, ease: 'none'})

  // .to(`${horeSel} .container-in`, {duration: 2, y: `+=${window.innerHeight + horeContentW - horeBoardsW}`, 
  // .to(`${horeSel} .container-in`, {duration: 2, y: `+=${decimalPlace(windowH + horeContentW - horeBoardsW)}`, ease: 'none'}, 0)
  // .to(`${horeSel} .container-in`, {duration: 2, y: `${horeContentW - horeBoardsW + windowH*0.5}`, 
  .to(`${horeSel} .container-in`, {duration: 2, y: `${horeContentW - horeBoardsW}`, 
    // .to(`${horeSel} .container-in`, {duration: 2, y: `${(horeContentW - horeBoardsW) / windowH * 100}%`, 

  // .to(`${horeSel} .container-in`, {duration: 2, y: `100%`, 
  // .to(`${horeSel} .container-in`, {duration: 2, y: `${windowH}`, 

    // modifiers: { y: y => Math.ceil(parseFloat(y)*100) / 100 + 'px'},
    // modifiers: { y: y => (parseFloat(y) + 0.75) + 'px'},

    ease: 'none'})

  // .to(`${horeSel} .container-in`, {duration: 2, y: `100%`, ease: 'none'})
  ;

  ////////////////////////////// Scroll2: Retouch content slide while scrolling
  horeScrollTl2 = gsapRef.timeline({
    scrollTrigger: {
    id: 'horeScrollTl2',
    trigger: horeSel,
    toggleActions: 'restart complete reverse reset',
    start: 'top top',
    end: `+=${horeContentW - horeBoardsW}` , // Used from .spacer-retouch
    scrub: 1.5,
    toggleClass: 'horeScrollTl2-active',
    onEnter: (self) => {},
    onLeave: (self) => {
      if(horeContentDrag) horeContentDrag.disable();
    },
    onEnterBack: (self) => {
      if(horeContentDrag) horeContentDrag.enable();
    },
    onLeaveBack: (self) => {},
    // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    }
  })
  .to(horeContentTl, {duration: 1.95, progress: 1, ease: 'none'}, 0.05)
  ;

  ////////////////////////////// Retouch on
  horeRetouchOnTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'horeRetouchOnTl',
      trigger: horeSel,
      start: 'top top',
      end: '+=0',
      toggleActions: 'restart none reverse none',
      onEnter: (self) => {
        smootherRef.paused(true);        
      },
      // onLeave: (self) => {},
      onEnterBack: (self) => {
        hophElsControl('play');

        smootherRef.paused(true);
        gsapRef.set(`${horeSel} .board-wrapper`, {pointerEvents: 'none'});
        if(horeContentDrag) horeContentDrag.disable();
      },
      // onLeaveBack: (self) => {},
    },
    // onStart: () => {},
    onComplete: () => {
      hophElsControl('pause');
      
      smootherRef.paused(false);
      gsapRef.set(`${horeSel} .board-wrapper`, {pointerEvents: 'all'});
      if(horeContentDrag) horeContentDrag.enable();  
    },
    onReverseComplete: () => {
      smootherRef.paused(false);
    }
  })
  .addLabel('t0', 0)

  .to(`.sector.graphic .contents-wrapper.photography .gallery-cover2`, {duration: 0.5, opacity: 1, ease: 'none'})

  .to('#brush-line', {duration: 1, strokeDashoffset: 0, ease: 'power1.inOut'}, 0)
  .to('#brush-line-g', {duration: 0.5, scale: horeBrushLineScale, ease: 'power1.inOut'}, '+=0.1')
  .to('#brush-rect', {duration: 0.2, fill: '#ffffff', ease: 'power1.out'}, '-=0.2')

  .addLabel('tCopyTitle', 't0+=0.1')

  .to(`${horeSel} .retouch-content-a .sector-copy.title .copy .char`, {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 'tCopyTitle')
  .to(`${horeSel} .retouch-content-b .sector-copy.title .copy .char`, {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 'tCopyTitle')
  .to(`${horeSel} .retouch-content-c .sector-copy.title .copy .char`, {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 'tCopyTitle')
  .to(`${horeSel} .retouch-content-d .sector-copy.title .copy .char`, {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 'tCopyTitle')

  .addLabel('tCopySentence')

  .to(`${horeSel} .retouch-content-a .sector-copy.sentance .copy .span`, {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, 'tCopySentence-=0.725')
  .to(`${horeSel} .retouch-content-b .sector-copy.sentance .copy .span`, {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, 'tCopySentence-=0.725')
  .to(`${horeSel} .retouch-content-c .sector-copy.sentance .copy .span`, {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, 'tCopySentence-=0.725')
  .to(`${horeSel} .retouch-content-d .sector-copy.sentance .copy .span`, {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, 'tCopySentence-=0.725')

  .addLabel('tBoardFold', '+=0.1')

  .to(`${horeSel} .contents-bg `, {duration: 0.4 + 0.4 - 0.0, scale: 1, opacity: 1, ease: 'power1.out'}, 'tBoardFold+=0.0')
  .to(`${horeSel} .cloud-in `, {duration: 0.4, opacity: 1, stagger: 0.2, ease: 'power1.out'}, 'tBoardFold+=0.2')
  
  .to(`${horeSel} .board-a`, {duration: 0.4 + 0.0, rotationY: '86deg', ease: 'none'}, 'tBoardFold')
  .to(`${horeSel} .board-b`, {duration: 0.4 + 0.0, rotationY: '-73deg', ease: 'power1.out'}, 'tBoardFold')
  .to(`${horeSel} .board-c`, {duration: 0.4 + 0.2, rotationY: '40deg', ease: 'power1.in'}, 'tBoardFold')
  .to(`${horeSel} .board-d`, {duration: 0.4 + 0.4, rotationY: '-40deg', ease: 'power1.inOut'}, 'tBoardFold')
  ;

  //////////////////// Draggable
  // contentDragRatio changed to the part in the horizontal sroll that's there to calculate the offset between the duration of the scroll and the amount of x-translation of the content (that needs to be included there when triggering things when certain sections reach a certain point in the viewport - as seen in commented out part above)
  var contentDragRatio = 1; // (horeContentW / (horeContentW - horeBoardsW));

  horeContentDrag = draggableRef.create(".retouch-drag-proxy", {
    trigger: `${horeSel} .contents-wrapper`,
    // trigger: `${horeSel} .board-wrapper`,
    // trigger: `${horeSel} .retouch-content`,
    type: "x",
    inertia: true,
    resistance: 15000,
    allowContextMenu: true,
    onPress() {
      this.startScroll = horeScrollTl2.scrollTrigger.scroll();
    },
    onDrag() {
      horeScrollTl2.scrollTrigger.scroll(this.startScroll - (this.x - this.startX) * contentDragRatio);
    },
    onThrowUpdate() {
      horeScrollTl2.scrollTrigger.scroll(this.startScroll - (this.x - this.startX) * contentDragRatio);
    }
  })[0];
  horeContentDrag.disable();


} // horeScrollMake END


////////////////////////////////////////////////// Scroll: clear
const horeScrollClear = () => {
  if(horeScrollTl1) {horeScrollTl1.revert(); horeScrollTl1 = null;}
  if(horeScrollTl2) {horeScrollTl2.revert(); horeScrollTl2 = null;}
  if(horeRetouchOnTl) {horeRetouchOnTl.revert(); horeRetouchOnTl = null;}
  if(horeContentTl) {horeContentTl.revert(); horeContentTl = null;}
  if(horeContentDrag) {horeContentDrag.kill(); horeContentDrag = null;}
  if(horeTitle) {horeTitle.revert(); horeTitle = null}
}


////////////////////////////////////////////////// Code for snippet
// if(horeIsSnippet) {
//   horeInit(gsap, splitText);
//   horeScrollMake(gsap, scrollTrigger, smoother, draggable);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation Control
const horeElsControl = (opt='play') => {
  // if(opt === 'play') {
  //   tlControl([hophWallLeftTl, hophWallRightTl, hophWallCenterTl], 'play');

  // } else {
  //   tlControl([hophWallLeftTl, hophWallRightTl, hophWallCenterTl], 'pause');
  // }
}



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing
const horeResizeStart = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home retouch] Resize: START");
}

const horeResizeDone = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef, draggableRef) => {
  console.log("[home retouch] Resize: END");

  horeScrollClear()
  horeInit(gsapRef, splitTextRef);
  horeScrollMake(gsapRef, scrollTriggerRef, smootherRef, draggableRef);
}

////////// Code for snippet
// let horeResizing = false;
// const horeResizeHandle = (e) => {
//   if(!horeResizing) {
//     horeResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     horeResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     horeResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     horeResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef, draggableRef);
//   }, 1000, 'horeResize');
// }
// if(horeIsSnippet) {
//   if(typeof horeIsRevert !== 'undefined') window.removeEventListener('resize', horeResizeHandleRef);
//   window.horeResizeHandleRef = horeResizeHandle;
//   window.addEventListener('resize', horeResizeHandleRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key
////////////////////////////////////////////////// Play / Pause Elements animation
const horeControlKey = (key) => {
  let opt;
  horeElsControl(opt);
  console.log(`[home: retouch] [key: ${key} pressed] Elements animation: ${opt}`);
};

////////////////////////////////////////////////// Code for snippet
// const horeControlKeyHandler = (e) => { if(e.key === '6') horeControlKey(e.key); }
// if(horeIsSnippet) {
//  if(typeof horeIsRevert !== 'undefined') window.removeEventListener('keydown', horeControlKeyHandlerRef);
//   window.horeControlKeyHandlerRef = horeControlKeyHandler;
//   window.addEventListener('keydown', horeControlKeyHandlerRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(horeIsSnippet) var horeIsRevert = true;


//////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  horeInit,
  horeScrollMake,
  horeScrollClear,
  horeResizeStart,
  horeResizeDone,
  horeControlKey
}